<template>
  <v-card-title class="ma-0 pa-0">
    <v-row class="ma-0 pa-0 mt-3" justify="start">
      <v-col cols="3" class="ma-0 pa-0">
        <v-row v-if="closable" class="ma-0 pa-0" justify="start" align="center">
          <v-btn
            @click="$emit('closeCard')"
            text
            class="text-none primary--text"
            >{{ labels.CLOSE }}
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="6" class="ma-0 pa-0">
        <v-row
          justify="center"
          align="center"
          class="vetalfa-row ma-0 pa-0 px-4"
        >
          <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
            {{ title }}
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-card-title>
</template>

<script>
import labels from "@/constants/labels.js";
export default {
  props: {
    closable: { type: Boolean, required: false, default: false },
    title: { type: String, required: true, default: "" },
  },
  data() {
    return {
      labels,
    };
  },
};
</script>
